import { AxiosResponse } from "axios"
import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"
import {
  TZyomuinListGetReq,
  TZyomuinListGetRes,
  TZyomuinSyozokuMasterGetReq,
  TZyomuinSyozokuMasterGetRes,
  TZyomuinGetRes,
  TZyomuinPutReq,
  TZyomuinPostReq,
  TZyomuinSyozokuMasterPutReq,
  TZyomuinGetByNameReq,
} from "./TZyomuin"

/**
 * 出勤簿に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class ZyomuinService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinListGetReq} params
   * @param {(param: TApiResponse<TZyomuinListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinListGetRes>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TZyomuinListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinListGetRes>> =
        await this.getInner(`/master/zyomuin`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 検索取得
   *
   * @param {TZyomuinListGetReq} params
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} reject
   */
  get = async (id: number) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinGetRes>> =
        await this.getInner(`/master/zyomuin/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 検索取得
   *
   * @param {TZyomuinGetByNameReq} params
   * @param {(param: TApiResponse<TZyomuinListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinListGetRes>) => any} reject
   * @memberof MenuService
   */
  getByName = async (params: TZyomuinGetByNameReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinListGetRes>> =
        await this.getInner(`/master/zyomuin/name`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * カードID検索取得
   *
   * @param {TZyomuinListGetReq} params
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} reject
   */
  getByCardId = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinGetRes>> =
        await this.getInner(`/master/zyomuin/get/cardId/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員所属マスタ一覧取得
   *
   * @param {TZyomuinSyozokuMasterGetReq} params
   * @memberof ZyomuinService
   */
  getSyozokuList = async (params: TZyomuinSyozokuMasterGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinSyozokuMasterGetRes[]>> =
        await this.getInner(`/driver/zyomuinsyozoku`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員所属マスタ単体取得
   *
   * @param {number} id
   * @memberof ZyomuinService
   */
  getSyozoku = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinSyozokuMasterGetRes>> =
        await this.getInner(`driver/zyomuinsyozoku/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員所属 単体更新
   *
   * @param {TZyomuinSyozokuMasterPutReq} data
   * @memberof SyaryoSyozokuService
   */
  putSyozoku = async (
    id: string | number,
    data: TZyomuinSyozokuMasterPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `driver/zyomuinsyozoku/update/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員所属 単体登録
   *
   * @param {TZyomuinSyozokuMasterPutReq} data
   * @memberof SyaryoSyozokuService
   */
  postSyozoku = async (
    id: string | number,
    data: TZyomuinSyozokuMasterPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `driver/zyomuinsyozoku/register/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TZyomuinPostReq} data
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZyomuinGetRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TZyomuinPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinGetRes>> =
        await this.postInner(`/master/zyomuin`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TZyomuinPutReq} data
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZyomuinGetRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: number, data: TZyomuinPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinGetRes>> =
        await this.putFormDataInner(`/master/zyomuin/${id}`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  //   /**
  //    * 単体取得
  //    *
  //    * @param {TMenuInfoGetReq} params
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
  //    * @memberof MenuService
  //    */
  //   get = async (id: string | number) => {
  //     try {
  //       // const res: AxiosResponse<TApiResponse<TSyukkinboInfoGetRes[]>> =
  //       // await this.getInner(`/master/hinmei`, params)
  //       //return res.data
  //       if (id === "3") {
  //         // eslint-disable-next-line no-throw-literal
  //         throw "ERROR"
  //       }

  //       return {
  //         data: dummyData[0],
  //       }
  //       //TODO: api実装必要
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体更新
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   put = async (id: string, data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //         `master/hinmei/${id}`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }
}
